<template>
    <div id="new-chat-flows-list" v-if="mariaIsEnabled">

        <div class="mr-12">

            <div class="flex">
                <div class="w-1/3">
                    <vs-input class="w-full" v-model="companyName" label="Nome da Empresa"/>
                    <span v-show="companyName.length >= 55" class="ml-2 mt-6 text-sm" style="color: #ff0000cc"> Número máximo atingido </span>
                </div>

                <div class="w-2/3 ml-4">
                    <vs-input class="w-full" @click="typeInfo" v-model="type" label="Tipo de Negócio"/>
                    <span v-show="type.length >= 40" class="ml-2 mt-6 text-sm" style="color: #ff0000cc"> Número máximo atingido </span>
                </div>

                <div class="w-full ml-4">
                    <vs-input class="w-full" v-model="address" label="Endereço"/>
                    <span v-show="address.length >= 150" class="ml-2 mt-6 text-sm" style="color: #ff0000cc"> Número máximo atingido </span>
                </div>
            </div>

            <div class="float-right mt-6">
                <vs-button @click.stop="infos.length === 3 ? updateInfos() : createInfos()" :disabled="
                    (
                        companyName.trim() === '' ||
                        address.trim() === ''     ||
                        address.length >= 150     ||
                        companyName.length >= 55  ||
                        type.trim() === ''        ||
                        type.length >= 40         ||
                        !canSee('create')
                    )
                ">
                    Salvar
                </vs-button>
            </div>

        </div>

        <br>

        <div class="mt-10">
            <h2 style="color: #6c6c6c;"> Segmentações </h2>
        </div>

        <div v-if="canSee('create')" @click="toggleSidebar(null, 'create')" class="mt-4" style="width: 160px;">

            <div class="p-3 mr-4 rounded-lg cursor-pointer flex items-center text-lg
                font-medium text-base text-primary border border-solid border-primary w-full"
            >
                <feather-icon icon="PlusIcon" svgClasses="h-4 w-4"/>
                <span
                    class="ml-2 text-base text-primary"
                >
                    Adicionar Novo
                </span>
            </div>

        </div>

        <vs-table 
            ref="table"
            :data="prompts"
            :sst="true"
            noDataText='Clique em "Adicionar Novo" para criar uma segmentação!'
            style="padding-right: 24px !important;"
        >
            <template slot-scope="{data}">
                <tbody>
                    <vs-tr 
                        :data="tr" 
                        :key="tr.id"
                        :id="tr.id"
                        v-for="(tr, index) in prompts"
                    >

                        <vs-td :title="tr.name" :data="tr.name" style="border-top-left-radius: 8px; border-bottom-left-radius: 8px;">
                            <p class="text-lg font-medium pl-20 truncate-text">
                                {{ tr.name }}
                            </p>
                        </vs-td>

                        <vs-td class="text-center" style="border-top-right-radius: 8px; border-bottom-right-radius: 8px;">
                            <feather-icon
                                @click.stop="toggleSidebar(tr, 'update')"
                                icon="EditIcon"
                                svgClasses="w-5 h-5 hover:text-primary"
                                v-if="canSee('edit')"
                            />

                            <feather-icon
                                @click.stop="toggleDeletePopUp(tr)"
                                icon="TrashIcon"
                                svgClasses="w-5 h-5 hover:text-danger"
                                class="ml-6"
                                v-if="canSee('delete')"
                            />
                        </vs-td>

                    </vs-tr>
                </tbody>
            </template>
        </vs-table>

        <div class="mt-3 mr-10">
            <vs-pagination
                :total="totalPages"
                v-model="page"
            />
        </div>

        <div>
            <vs-popup title="Remover Segmentação" :active.sync="deletePopUpIsActive" @close="deletePopUpIsActive = false">
                <p class="text-left">Deseja realmente remover a Segmentação de nome <strong> {{ dataToDelete.name }} </strong>
                    das opções do Fluxo Bot de Triagem da Mar.IA ?
                </p> <br>

                <div class="w-full d-flex justify-content-flex-end">
                    <vs-button color="danger" @click.stop="remove()">Remover</vs-button>
                </div>
            </vs-popup>
        </div>

        <Sidebar
            :isActive="sidebarIsActive"
            :context="sidebarContext"
            :departments="userDepartments"
            :data="sidebarData"
            @isActiveFalse="sidebarIsActive = false"
        />

    </div>
</template>

<script>

    import Sidebar from './NewChatFlowsSidebar.vue';
    import { hasPermission, hasFeature } from '@/utils';
    import modulePrompt from '@/store/prompt/modulePrompt';
    import moduleUserDepartment from '@/store/userDepartment/moduleUserDepartment';

    export default {
        data() {
            return {
                companyName: '',
                address: '',
                page: 1,
                itemsPerPage: 4,
                sidebarIsActive: false,
                mariaIsEnabled: false,
                sidebarContext: '',
                sidebarData: {
                    id: null,
                    key: null,
                    name: null,
                    option: null,
                    prompt_id: null,
                    department_id: null
                },
                deletePopUpIsActive: false,
                dataToDelete: {
                    id: null,
                    name: null,
                },
                isMounted: false,
                type: '',
                notifyEnabled: true,
                count: 0
            }
        },
        components: {
            Sidebar
        },
        computed: {
            prompts() {
                return this.$store.state.prompt.prompts.items || [];
            },
            userDepartments() {
                return this.$store.state.userDepartment.userDepartments;
            },
            totalPages() {
                return this.$store.state.prompt
                    && this.$store.state.prompt.prompts.total_pages
                    ? this.$store.state.prompt.prompts.total_pages
                    : 0
            },
            infos() {
                return this.$store.state.prompt.prompts.infos === undefined
                ? [] : this.$store.state.prompt.prompts.infos;
            }
        },
        watch: {
            'page'() {
                this.fetch();
            },
            'itemsPerPage'() {
                this.page = 1;
                this.fetch();
            },
            'prompts'( newVal ) {
                if ( newVal !== undefined && newVal.length === 5 && this.isMounted ) {
                    this.fetch();
                }
            },
            companyName( value ) {
                if ( value && value.length === 55 ) {
                    this.$vs.notify(
                        {
                            color: 'warning',
                            title: 'Atenção!',
                            text: 'Número máximo de caracteres atingido no campo nome da empresa!',
                            time: 5000
                        }
                    );
                }
            },
            address( value ) {
                if ( value && value.length === 150 ) {
                    this.$vs.notify(
                        {
                            color: 'warning',
                            title: 'Atenção!',
                            text: 'Número máximo de caracteres atingido no campo endereço!',
                            time: 5000
                        }
                    );
                }
            },
            type( value ) {
                if ( value && value.length === 40 ) {
                    this.$vs.notify(
                        {
                            color: 'warning',
                            title: 'Atenção!',
                            text: 'Número máximo de caracteres atingido no campo de tipo de negócio!',
                            time: 5000
                        }
                    );
                }
            },
            sidebarIsActive( value ) {
                if ( !value ) this.countOptions();
            }
        },
        methods: {
            typeInfo() {
                if (!this.notifyEnabled) {
                    return;
                }

                this.notifyEnabled = false;
                this.$vs.notify(
                    {
                        color: 'primary',
                        title: 'Aviso importante:',
                        text: `No campo de "Tipo de Negócio" você deve informar o tipo de segmentação da sua empresa, 
                        como por exemplo: Farmácia, Papelaria, Advocacia, Contabilidade, Mercado, Laboratório, Universidade,
                        Imóveis, Cartório, etc...
                        `,
                        time: 25000
                    }
                );

                setTimeout( () => this.notifyEnabled = true, 10000 );
            },
            async fetch() {
                await this.$store.dispatch("prompt/fetch",
                    {
                        prompt_id: 1,
                        key: '{options}',
                        page: this.page,
                        itemsPerPage: this.itemsPerPage
                    }
                );

                await this.fetchInfos();
                await this.countOptions();
            },
            async fetchInfos() {
                await this.$store.dispatch("prompt/fetchInfos",
                    {
                        prompt_id: 1,
                        key: '{company_infos}',
                    }
                );

                this.setInfos();
            },
            async countOptions() {
                await this.$store.dispatch("prompt/countOptions").then( response => this.count = response );
            },
            toggleSidebar(data = null, context) {

                if (this.count >= 10 && context === 'create') return this.$vs.notify(
                    {
                        color: 'warning',
                        title: 'O número máximo de opções foi atingido!',
                        text: 'Estamos trabalhando para aumentar a quantidade de opções que podem ser configuradas. Por enquanto, disponibilizamos apenas 10 segmentações, mas em breve uma quantidade ilimitada será liberada',
                        time: 19000
                    }
                );

                if (context === 'update') {
                    this.sidebarData = {
                        ...data
                    };
                }

                this.sidebarContext  = context;
                this.sidebarIsActive = true;

            },
            toggleDeletePopUp(data) {
                this.dataToDelete.id     = data.id;
                this.dataToDelete.name   = data.name;
                this.deletePopUpIsActive = true;
            },
            async remove() {
                await this.$store.dispatch("prompt/delete", this.dataToDelete.id)
                .then( () => {
                    this.deletePopUpIsActive = false;
                    this.dataToDelete        = {
                        id: null,
                        name: null,
                    };

                    this.fetch();
                    this.$vs.notify(
                        {
                            color: 'success',
                            title: 'Sucesso!',
                            text: 'A Segmentação foi deletada com Sucesso!',
                            time: 5000
                        }
                    );
                })
                .catch( () => {
                    this.$vs.notify(
                        {
                            color: 'danger',
                            title: 'Erro!',
                            text: 'Algo deu errado ao deletar a Segmentação!',
                            time: 5000
                        }
                    );
                });
            },
            async createInfos() {

                await Promise.all(
                    [
                        this.$store.dispatch("prompt/createInfos",
                            {
                                key: '{company_name}',
                                name: this.companyName,
                                prompt_id: 1
                            }
                        ),
                        this.$store.dispatch("prompt/createInfos",
                            {
                                key: '{address}',
                                name: this.address,
                                prompt_id: 1
                            }
                        ),
                        this.$store.dispatch("prompt/createInfos",
                            {
                                key: '{type}',
                                name: this.type,
                                prompt_id: 1
                            }
                        )
                    ]
                );

                this.setInfos();
                this.$vs.notify(
                    {
                        color: 'success',
                        title: 'Sucesso!',
                        text: 'Os dados foram criados com Sucesso!',
                        time: 5000
                    }
                );

            },
            async updateInfos() {

                const companyNameIndex = this.infos.findIndex( item => item.key === "{company_name}" );
                const addressIndex     = this.infos.findIndex( item => item.key === "{address}" );
                const typeIndex        = this.infos.findIndex( item => item.key === "{type}" );

                if ( companyNameIndex !== - 1 ) {

                    await this.$store.dispatch("prompt/updateInfos",
                        {
                            id: this.infos[companyNameIndex].id,
                            name: this.companyName
                        }
                    );

                }

                if ( addressIndex !== - 1 ) {

                    await this.$store.dispatch("prompt/updateInfos",
                        {
                            id: this.infos[addressIndex].id,
                            name: this.address
                        }
                    );

                }

                if ( typeIndex !== - 1 ) {

                    await this.$store.dispatch("prompt/updateInfos",
                        {
                            id: this.infos[typeIndex].id,
                            name: this.type
                        }
                    );

                }

                if ( companyNameIndex !== - 1 && addressIndex !== - 1 && typeIndex !== - 1 ) {

                    this.$vs.notify(
                        {
                            color: 'success',
                            title: 'Sucesso!',
                            text: 'Os dados foram atualizados com Sucesso!',
                            time: 5000
                        }
                    );

                }

                this.setInfos();

            },
            setInfos() {
                const companyNameIndex = this.infos.findIndex( item => item.key === "{company_name}" );
                const addressIndex     = this.infos.findIndex( item => item.key === "{address}" );
                const typeIndex        = this.infos.findIndex( item => item.key === "{type}" );

                companyNameIndex !== - 1 ? ( this.companyName = this.infos[companyNameIndex].name ) : this.companyName = '';
                addressIndex     !== - 1 ? ( this.address     = this.infos[addressIndex].name ) :     this.address     = '';
                typeIndex        !== - 1 ? ( this.type        = this.infos[typeIndex].name ) :        this.type        = 'Farmácia';
            },
            canSee(action) {
                return hasPermission(`${this.$route.name}-${action}`)
            }
        },
        async created() {
            this.mariaIsEnabled = await hasFeature('maria');

            if (!modulePrompt.isRegistered) {
                this.$store.registerModule('prompt', modulePrompt);
                modulePrompt.isRegistered = true;
            }

            if (!moduleUserDepartment.isRegistered) {
                this.$store.registerModule('userDepartment', moduleUserDepartment);
                moduleUserDepartment.isRegistered = true;
            }

            await Promise.all(
                [
                    this.$store.dispatch("userDepartment/fetch"),
                    this.fetch()
                ]
            );
        },
        mounted() {
            this.isMounted = true;
        },
        beforeRouteLeave(to, from, next) {
            this.deletePopUpIsActive = false;
            this.sidebarIsActive     = false;
            setTimeout( ()=> {
                next();
            }, 2);
        }
    }
</script>

<style lang="scss">

    #new-chat-flows-list {

        input {
            box-shadow: 2px 2px 3px 0px rgba(31, 29, 29, 0.116) !important;
        }

        > div:nth-child(1) input {
            height: 42px;
            border-radius: 10px;
            border-color: rgba(0, 0, 0, 0.247) !important;
        }
        table.vs-table.vs-table--tbody-table {
            border-collapse: separate;
            border-spacing: 0 1.0rem;
            padding-right: 1rem;
        }
        tbody > tr {
            height: 40px;
            box-shadow: 2px 4px 20px 0 rgba(0, 0, 0, 0.05);

            td.td.vs-table--td:first-of-type {
                width: 80% !important;
            }
        }

        .truncate-text {
            max-width: 750px;
            overflow: hidden !important;
            white-space: nowrap !important;
            text-overflow: ellipsis !important;
        }

    }

</style>